import{init_define_globalThis_WASM_METADATA as r}from"./chunk-NATRJZ7H.js";r();var o={};export{o as translations};